import React from 'react';
import { Separator } from '@/components/ui/separator';
import { Mail, ExternalLink } from 'lucide-react';
import siteData from '@/data/siteData.json';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const navLinks = [
    { label: 'Início', href: '#hero' },
    { label: 'Produtos', href: '#produtos' },
    { label: 'Marcas', href: '#marcas' },
    { label: 'Sobre', href: '#sobre' },
    { label: 'Contato', href: '#contato' },
  ];

  const handleNavClick = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-foreground text-background py-16">
      <div className="section-container">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <img
              src={siteData.company.logo}
              alt={siteData.company.name}
              className="h-12 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-background/70 text-sm leading-relaxed max-w-md mb-6">
              {siteData.company.description}
            </p>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-background/10 flex items-center justify-center">
                <Mail className="h-5 w-5 text-background" />
              </div>
              <div>
                <p className="text-xs text-background/50 mb-0.5">Email</p>
                <a
                  href={`mailto:${siteData.company.email}`}
                  className="text-sm text-background hover:text-background/80 transition-colors"
                >
                  {siteData.company.email}
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display font-semibold text-background mb-4">
              Links Rápidos
            </h4>
            <nav className="space-y-3">
              {navLinks.map((link) => (
                <button
                  key={link.href}
                  onClick={() => handleNavClick(link.href)}
                  className="block text-sm text-background/70 hover:text-background transition-colors"
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-display font-semibold text-background mb-4">
              Categorias
            </h4>
            <nav className="space-y-3">
              {siteData.categories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => handleNavClick('#produtos')}
                  className="block text-sm text-background/70 hover:text-background transition-colors"
                >
                  {category.shortName}
                </button>
              ))}
            </nav>
          </div>
        </div>

        {/* Brands */}
        <div className="mb-12">
          <h4 className="font-display font-semibold text-background mb-4 text-center">
            Marcas Parceiras
          </h4>
          <div className="flex flex-wrap justify-center items-center gap-8">
            {siteData.brands.map((brand) => (
              <span
                key={brand.id}
                className="text-sm text-background/50 hover:text-background/70 transition-colors"
              >
                {brand.name}
              </span>
            ))}
          </div>
        </div>

        <Separator className="bg-background/10 mb-8" />

        {/* Bottom Footer */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-background/50">
            © {currentYear} {siteData.company.name}. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-2 text-sm text-background/50">
            <ExternalLink className="h-4 w-4" />
            <span>{siteData.company.domain}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
